import { TenantContact } from "../../Models/TenantContact";
import api from "../axios";

export const tenantContactService = {
  get: async (): Promise<TenantContact> => {
    const response = await api.get('/tenant-contact');
    return response.data;
  },

  update: async (data: TenantContact): Promise<boolean> => {
    const response = await api.put('/tenant-contact', data);
    return response.data;
  }
};
